<!--
Support confirmation screen
@author cm359n
-->
<template>
  <div id="contain" class="container">
  <Nav name="App Support" :step="true" :showNotif="true" />
  <Spinner ref="spinner" />
    <div>
      <div class="mappedWarning" v-if="notEmpty(mappedGuid)">You are currently mapped to user <b>{{ mappedGuid }} ({{ customerName }})</b>. Incident submission will be disabled.</div>
    <main class="p-2" id="supportmain">
      <div class="helpWithOther">
        <p class="supportSectionHdr">How can we help?</p>
        <p class="linksHeader">Use the links below for support.</p>
        <table class="supportLinks">
          <tr v-bind:key="index" v-for="(item, index) in supportItems"><td class="support-text">
            <span class="support-content">
            <a href="#" v-on:click="go(item.url)">
              <font-awesome-icon size="lg" class="support-icon" :icon="item.icon"></font-awesome-icon>{{ item.text }}
              <font-awesome-icon class="support-arrow" icon="arrow-right"></font-awesome-icon>
            </a>
            </span>
          </td></tr>
        </table>
      </div>
      <div class="howCanWeHelp">
      <p class="supportSectionHdr">Help with other issues</p>
      <p class="supportSubmitMsg">
Tell us about your experience and any issues you've encountered with the app and someone from the support team will get back to you via email.
</p>
      <form target="_blank" name="bookingForm">
         <div class="supportForm">
            <textarea placeholder="Enter your issue" name="body" :onchange="checkSupport()" class="supportArea" v-model="body" />
            <div id='supportBtn'>
              <input :disabled="disableSupport" type="button" value="Submit" id="contactSupport" @click="contactSupport" class="supportButton"/>
            </div>

         </div>
      </form>
      </div>
      <div>&nbsp;</div>
    </main>
    </div>
     <NewModalPopup v-if="showErrorPopup" id="error" title="Failed to create Incident">
      <p>Sorry, your helpdesk request could not be created. Please wait a moment and try again.</p>
      <button class="btn btn-secondary" @click="showErrorPopup = false">OK</button>
    </NewModalPopup>
    <Footer active="index"/>
  </div>
</template>

<script setup>
//Utilities
import { ref, onMounted } from 'vue'
import axios from 'axios'
import * as lst from '@/components/localStorage.js'
import { useRouter } from 'vue-router'
const router = useRouter()

//Composables
import { useStringUtil } from '@/composables/StringMethods.js'
//const { isEmpty } = useStringUtil()

//Components
import Spinner from '@/components/Spinner.vue'
import Footer from '@/components/FooterMenu.vue'
import NewModalPopup from '@/components/NewModalPopup.vue'

//Data
let cname = lst.getValue('name')
if (typeof cname !== 'undefined') {
  cname = cname.replace(',', ' ')
}
const setMappedGuid = lst.getValue('mappedGuid')

const body = ref('')
const urls = ref({})
const mappedGuid = ref(setMappedGuid)
const errorMessage = ref('')
const showErrorPopup = ref(false)
const customerName = ref(cname)
const disableSupport = ref(true)
const supportItems = ref([ /* keep the failsafe links in just in case */
  {
    name: 'emergency',
    url: 'https://www.gla.ac.uk/myglasgow/students/safetyhealth/',
    text: "It's an emergency",
    icon: 'exclamation-circle'
  },
  {
    name: 'enrolment',
    url: 'https://glasgow.saasiteu.com/Modules/SelfService/Login.aspx?ProviderName=University%20of%20Glasgow&Role=SelfServiceMobileStudent&Tab=ServiceCatalog&CommandId=NewServiceRequestByOfferingId&Template=DAFC979B5E0C4FED964571B4F44AC19B',
    text: 'Reg & enrolment issues',
    icon: 'file-signature'
  },
  {
    name: 'timetable',
    url: 'https://glasgow.saasiteu.com/Modules/SelfService/Login.aspx?ProviderName=University%20of%20Glasgow&Role=SelfServiceMobileStudent&Tab=ServiceCatalog&CommandId=NewServiceRequestByOfferingId&Template=DAFC979B5E0C4FED964571B4F44AC19B',
    text: 'Timetable issues',
    icon: 'calendar-alt'
  },
  {
    name: 'personal',
    url: 'https://www.gla.ac.uk/myglasgow/counselling/self-help/',
    text: 'Personal issue',
    icon: 'user'
  },
  {
    name: 'other',
    url: 'https://www.gla.ac.uk/help',
    text: 'Other',
    icon: 'question-circle'
  }
])
const submitData = ref(null)

//Component refs
const spinner = ref(null)

onMounted(
  () => {
    fetchLinks()
    console.log(mappedGuid.value)
  }
)

function replaceSupportLinks () {
  const urlnames = Object.keys(urls.value)
  // console.log(urlnames)
  for (let l of supportItems.value) {
    if (urlnames.indexOf(l.name) != -1) {
      let oldurl = l.url
      let newurl = urls.value[l.name]
      if (oldurl !== newurl) {
        console.log('help item ' + l.name + ' has new url, replacing it')
        l.url = newurl
      }
    }
  }
}

function fetchLinks () {
  axios.get('/timetable/banners/category/12', {})
    .then(response => {
      // take one banner and display it
      let banners = response.data.banners
      if (typeof banners !== 'undefined' && banners.length > 0) {
        banners.map((b) => {
          urls.value[b.title] = b.content
        })
        replaceSupportLinks()
      }
    })
    .catch((error) => {
      console.log('error fetching helpdesk tile content: ' + error)
    })
}

function notEmpty (str) {
  if (typeof str === 'undefined') {
    return false
  }
  if (str === '' || str == null) {
    return false
  }
  return true
}

function go (dest) {
  if (typeof dest === 'undefined' || dest === 'tbc') {
    alert('Sorry, no URL has been defined for this item - taking you to Helpdesk')
    dest = 'https://www.gla.ac.uk/help'
  }
  window.open(dest)
}

function checkSupport () {
  errorMessage.value = ''
  disableSupport.value = (body.value.length < 20)
  if (notEmpty(mappedGuid.value)) {
    disableSupport.value = true
  }
}

function createData () {
  submitData.value = {}

  submitData.value.givenName = customerName.value
  submitData.value.body = body.value
  submitData.value.subject = 'UofG Life Incident'
  console.log(submitData.value)
}

function contactSupport () {
  disableSupport.value = true // avoid double-submits!
  spinner.value.spin()
  createData()

  window.errorOverride = function (msg) {
    errorMessage.value = msg
    // show modal
    // $('#errorModal').modal('show')
    showErrorPopup.value = true
    disableSupport.value = false
  }

  axios.post('/timetable/ivanti/request', submitData.value)
    .then(response => {
      console.log(response.data)

      // ... and then ...
      let incidentNumber = response.data
      router.push('/support/confirmation/' + incidentNumber)
    })
    .catch(error => {
      alert(error)
      disableSupport.value = false
      spinner.value.stop()
    })
    .finally(() => {
      // this.$refs.spinner.stop()
    })
}

</script>


<style scoped>
.mappedWarning {
  background-color:#0274af;
  color: #ffffff;
}
span.support-content {
  margin-left: 24px;
  margin-right: 24px;
  white-space: initial;
  white-space: nowrap;
}
input.searchButton:disabled {
  background: #9512726b;
}
.support-icon {
  margin-right: 10px;
  width:30px;
}
.support-text {
  font-size: 18px;
  font-weight: 700px;
}
.linksHeader {
  margin-left: 24px;
  color: #4F5961;
  font-size: 18px;
  font-weight: 400;
}
.helpWithOther a {
  color: #003865;
}
.helpWithOther {
  color: #003865;
  margin-right: 24px;
  margin-bottom: 25px;
  width: 100%;
}

.support-arrow {
  float: right;
  margin-top: 5px;
  margin-right: 24px;
}
input.supportButton {
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 21px;
  align-items: center;
  text-align: center;
  color: #FFFFFF;
  height: 55px;
  width: 95%;
  margin-bottom: 24px;
  background: #003865;
  border-radius: 16px;
}

.supportSubmitMsg {
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 21px;
    text-align: left;
    color: #4F5961;
    margin-left: 20px;
    width: 93%;
}
table.supportLinks {
  width: 100%;
  margin-top: 20px;
  border-bottom: 1px solid #e4e4e4;
}
table.supportLinks td {
  border-top: 1px solid #e4e4e4;
  font-weight: 700;
  height: 48px;
  vertical-align: middle;
}
.supportArea {
    width: 95%;
    height: 142px;

    background: rgba(118, 118, 128, 0.12);
    border: none;
    box-sizing: border-box;
    border-radius: 10px;
    font-size:18px;
}

div.supportForm {
    text-align: left;
    margin-left:20px;
}

.dispStar {
  width: 28px;
  height: 28px;

}

#supportBtn {
  margin-top:24px;
}

#supportBtn input:disabled {
  opacity: 0.5;
}

main.p-2#supportmain {
    text-align: left;
}
supportLinks {
  display: block;
}
img#supportEndImg {
    margin-top: 62px;
}
p.roomMessage {
  color: red;
}
.supportSectionHdr {
  font-style: normal;
  color: #003865;
  font-weight: 700;
  font-size: 20px;
  text-align: left;
  line-height: 32px;
  margin-top: 15px;
  margin-left: 24px;
}
.supportSubmitSubHdr {
    margin-top: 3px;
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    line-height: 26px;
    text-align: left;

    color: #005C8A;
}

</style>
